var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-tabs',{attrs:{"value":_vm.activeName},on:{"tab-click":_vm.handleClick}},[_c('el-tab-pane',{attrs:{"name":"aiexam","label":"ai面试","lazy":true}},[_vm._v("abc")]),_c('el-tab-pane',{attrs:{"name":"exam","label":"在线考试","lazy":true}},[_c('exam-list',{staticStyle:{"margin":"0 50px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }